import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogClickEditOn = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(() => {
    logAnalyticsEvent({ name: 'CLICK_EDIT_ON' });
  }, [logAnalyticsEvent]);
};
